var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textToSpeech"},[(!_vm.enabled)?_c('div',{staticClass:"start",on:{"click":function($event){return _vm.start()}}}):_vm._e(),(_vm.enabled)?_c('div',{staticClass:"stop",on:{"click":function($event){return _vm.stop()}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }